import React from 'react';

import flatAbout from '../../assets/images/flat_about.png';

import cv from './curriculo.pdf';

import './styles.css';

export default function About() {
    return(
        <div className="about-container" id="about">
            <div className="about-content">
                <div className="flat-about">
                    <img 
                        src={ flatAbout } 
                        alt="Ilustração" 
                    />
                </div>
                <div className="about-text">
                    <p>
                        <h1>Sobre mim</h1>
                        Estou cursando Ciência da Computação na Pontifícia Universidade Católica de Goiás (PUC GO), além disso tenho formação como Técnico em Design Gráfico.
                        <br /><br />
                        Amo programação e estou disponível para trabalhos freelas, pronto para participar em novos projetos e aprender ainda mais sobre esse mundo do desenvolvimento.
                    </p>
                </div>
                <a 
                    className="about-btn-cv"
                    href={ cv }
                    target="_blank"
                >
                    Meu CV
                </a>
            </div>
        </div>
    );
}